import { CdkScrollable } from '@angular/cdk/scrolling';
import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { UnsubscribeService } from '@webgate/angular-azure-core';
import { AzureIdStatusPipe } from 'src/app/pipes/azure-id-status.pipe';
import { UserNamePipe } from 'src/app/pipes/user-name.pipe';

import { Organization } from '../../models/organization';
import { Roles } from '../../models/roles';
import { ResponsiblesService } from '../../services/responsibles.service';
import { PersonSelectComponent } from '../person-select-dialog/person-select.component';

@Component({
  selector: 'app-change-responsibles',
  templateUrl: './change-responsibles.component.html',
  styleUrls: ['./change-responsibles.component.scss'],
  imports: [
    AzureIdStatusPipe,
    UserNamePipe,
    AsyncPipe,
    MatIconModule,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogClose
  ]
})
export class ChangeResponsiblesComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  private responsibleService = inject(ResponsiblesService);
  dialog = inject(MatDialog);
  disabled!: true;
  json: Record<string, unknown> = {};
  responsibles: Record<string, unknown> = {};
  fields: { key: string; persons: { id?: string; name?: string; mail?: string }[] }[] = [];
  fieldNames!: string[];
  form!: UntypedFormGroup;
  organization!: Organization;
  roles: string[] = [];
  unsubscribeService = inject(UnsubscribeService);

  ngOnInit() {
    this.initializeForm();
    this.setData();
  }

  setData() {
    console.log(this.organization);
    if (this.organization) {
      //TODO Set from Organization
    }
  }

  getList(fieldName: string): string[] {
    return this.responsibles[fieldName] as string[];
  }

  findName(key: string): string {
    switch (key) {
      case 'headLegalUnit':
        return 'Head Legal Unit';
      case 'chifFinanceAdministration':
        return 'Chief Finance & Administration';
      case 'headHumanResources':
        return 'Head Human Resources';
      case 'responsibleForCommunication':
        return 'Responsible for Communication';
      case 'qualityManager':
        return 'Quality Manager';
      case 'exportControllOfficer':
        return 'Export Control Manager';
      case 'itResponsible':
        return 'IT Responsible';
      case 'transferPricingOfficer':
        return 'Transfer Pricing Officer';
      case 'headOfWorkerCouncel':
        return 'Head of Workers Councel';
      case 'responsibleForContractFilling':
        return 'Responsible for Contract filling';
      case 'savetyEnvirionmentOfficer':
        return 'Safety & Environment Officer';
      case 'insuranceOfficer':
        return 'Insurance Officer';
      case 'patentOfficer':
        return 'Patent Officer';
      case 'tradeFinanceOfficer':
        return 'Trade Finance Officer';
      case 'productSafetyOfficer':
        return 'Product Safety Officer';
      default:
        return key;
    }
  }

  initializeForm() {
    this.form = this.data.formGroup;
    let arr = [];
    if (this.data.organizations) {
      arr = this.data.organizations.filter((org: Organization) => {
        return org.abbreviation === this.form.value.legalUnit;
      });
    }
    if (arr.length > 0) {
      this.organization = arr[0];
    }
    switch (this.form?.controls.auditor.value) {
      case 'GPRM':
        this.roles.push(Roles.Authors_GPRMAUD);
        this.roles.push(Roles.Authors_GPRMCOR);
        break;
      case 'GPIA':
        this.roles.push(Roles.Authors_GPIAAUD);
        this.roles.push(Roles.Authors_GPIACOR);
        break;
    }
  }

  sendToUserSelect(person: { mail?: string; id?: string; name?: string }, field: string) {
    if (field === 'emailAddress' && person.mail) {
      const val = this.form.get(field)?.value;
      val.push(person.mail);
      this.form.get(field)?.setValue(val);
    } else if (field === 'assessmentCoordinator' && person.id) {
      this.form.get(field)?.setValue(person.id);
    } else if (person.id) {
      const val = this.form.get(field)?.value;
      val.push(person.id);
      this.form.get(field)?.setValue(val);
    }
  }

  isValidName(name: string): boolean {
    if (name === '-- not required --' || name === 'n.a.') {
      return false;
    } else {
      return true;
    }
  }

  removeMail(index: number) {
    this.form.get('emailAddress')?.value.splice(index, 1);
  }

  addMail(mail?: string) {
    if (!mail) return;
    const arr = this.form.get('emailAddress')?.value;
    arr.push(mail);
    this.form.get('emailAddress')?.setValue(arr);
  }

  selectPerson(fieldName: string, single = false): void {
    this.dialog
      .open(PersonSelectComponent, {
        data: {
          currentPeople: single ? [this.form.get(fieldName)?.value] : this.form.get(fieldName)?.value,
          singleSelect: single,
          dialogTitle: this.getDialogTitle(fieldName)
        }
      })
      .afterClosed()
      .pipe(this.unsubscribeService.takeUntilDestroy)
      .subscribe((data: { save: boolean; id: string; userIds: string[] }) => {
        if (!data?.save) return;
        if (single) {
          this.form.get(fieldName)?.setValue(data.id);
        } else {
          this.form.get(fieldName)?.setValue(data.userIds);
        }
      });
  }

  getDialogTitle(fieldName: string): string {
    return fieldName === 'assessmentCoordinator'
      ? '1. Auditee'
      : fieldName === 'legalUnitResponsibles'
      ? '2. LU responsibles'
      : '3. Others';
  }
}
